
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tposts/[id]",
      function () {
        return require("private-next-pages/tposts/[id]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tposts/[id]"])
      });
    }
  